import { useContext, useEffect, useState } from "react";
import { MissionContext, UiComponentContext } from "./MissionWorkflowComponent";
import { Action } from "../Types";
import { Button, Dropdown, Input, Label } from "semantic-ui-react";
const w = window as any

function AddCommentView(props: Action) {
    const { setUiComponent } = useContext(UiComponentContext);
    const { mission } = useContext(MissionContext);
    const [type, setType] = useState("");
    const [comments, setComments] = useState<string[]>([]);
    const [flights, setFlights] = useState<string[]>([]);
    const [selectedFlight, setSelectedFlight] = useState("");
    const [selectedComment, setSelectedComment] = useState("");


    useEffect(() => {
        function initComments() {
            const commentsList = [""]
            w.XopsLocalStorage.getStartComments().forEach((comment: string) => commentsList.push(comment))
            setComments(commentsList)
        }
        function initFlights() {
            const flightsList: string[] = []
            mission.data.flights.forEach(flight => flightsList.push(flight.flightName))
            setFlights(flightsList)
            setSelectedFlight(flightsList[0])
        }
        initComments()
        initFlights()
    }, [])


    const handleFlightChange = (event: any) => {
        setSelectedFlight(event.target.textContent);
    };

    const handleCommentChange = (event: any) => {
        setSelectedComment(event.target.textContent);
    };

    const handleTypeChange = (event: any) => {
        setType(event.target.value.toUpperCase());
    };

    const handleOkButton = () => {
        const response = saveEvent(selectedComment, type, selectedFlight, props)
        if (response) {
            setUiComponent(null)
        }
    }

    return (
        <div>
            <div>
                <div>
                    <div>
                        <Label style={{ color: "initial" }}>Commentaires</Label>
                    </div>
                    <br></br>
                    <div>
                        <div>
                            <Label style={{ color: "initial" }}>Vol</Label>
                            <div>
                                <Dropdown
                                    selection
                                    id="type-select"
                                    value={selectedFlight}
                                    options={flights.map(flight => ({ key: flight, text: flight, value: flight }))}
                                    onChange={handleFlightChange}
                                />
                            </div>
                        </div>
                        <br></br>
                        <div>
                            <Label style={{ color: "initial" }}>&lt;Choisir un commentaire prédéfini&gt;</Label>
                            <div>
                                <Dropdown
                                    selection
                                    id="type-select"
                                    value={selectedComment}
                                    options={comments.map((comment: string) => ({ key: comment, text: comment, value: comment }))}
                                    onChange={handleCommentChange}
                                />
                            </div>
                        </div>
                        <br></br>
                        <div>
                            <Label style={{ color: "initial" }}>Autre</Label>
                            <div>
                                <Input type="text" data-testid="commentInput" autoFocus={true} value={type} onChange={handleTypeChange} />
                            </div>
                        </div>
                        <br></br>
                        <div>
                            <div>
                                <Button data-testid="OK" onClick={handleOkButton}>OK</Button>
                            </div>
                            <br></br>
                            <div>
                                <Button onClick={() => setUiComponent(null)}>
                                    <span className="glyphicon glyphicon-arrow-left" style={{ paddingRight: "5px" }}> </span>Retour Menu
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="developmentDiv"></div>
        </div>
    );
}

interface eventDataObject {
    actions: Action[],
    comment: string,
    type: string,
    flight: string,
    label: string,
    notificationCategory: string,
}

function saveEvent(commentList: string, commentInput: string, flight: string, data: any) {
    try {
        if (commentList == '' && commentInput == '') {
            console.error("no comment entered")
            return false
        } else {
            var eventData: eventDataObject = {} as eventDataObject;
            eventData.actions = [data];
            eventData.comment = commentList;
            eventData.type = commentInput;
            eventData.flight = flight
            eventData.label = `<b>${commentList}</b> <b>${commentInput}</b>`;
            eventData.notificationCategory = "comment";

            console.log(w.XopsGlobals.getInstance())
            const mission = w.XopsGlobals.getInstance().currentView.missionContext.mission
            const stopId = mission.attributes.currentStopId
            const taskId = null
            w.localStorageController.saveEvent(w.EventsUtils.getInstance().populateNewEvent({ type: "COMMENT" }, eventData, mission, stopId, taskId), null, true);
            return true
        }
    } catch (e) {
        console.error(e)
        return false
    }
}


export default AddCommentView;